interface AnnouncementsGateState {
  eligibleCount: number;
  hiddenForSession: boolean;
  isAnotherGuideVisible: boolean;
  isSettling: boolean;
  open: boolean;
  showPending: boolean;
  signedIn: boolean;
}

type AnnouncementsGateAction = "hold" | "none" | "open" | "skip";

// Opens only for a pending trigger; a visible guide keeps the trigger waiting, and a page still
// settling holds the slot until it can open.
const getAnnouncementsGateAction = ({
  eligibleCount,
  hiddenForSession,
  isAnotherGuideVisible,
  isSettling,
  open,
  showPending,
  signedIn,
}: AnnouncementsGateState): AnnouncementsGateAction => {
  if (open || !signedIn || !showPending) {
    return "none";
  }
  if (hiddenForSession || eligibleCount === 0) {
    return "skip";
  }
  if (isAnotherGuideVisible) {
    return "none";
  }
  return isSettling ? "hold" : "open";
};

export default getAnnouncementsGateAction;
